import type { TemplateItem } from '@cognite/apm-client';

export function sortTemplateItems(
  templateItems: TemplateItem[]
): TemplateItem[] {
  return [...templateItems].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}
